module.exports = __webpack_public_path__ + "static/media/free-car-removal.f30e5743.png";